import { Component } from '@angular/core';
declare var $:any


@Component({
  selector: 'app-send-updates',
  templateUrl: './send-updates.component.html',
  styleUrls: ['./send-updates.component.scss']
})
export class SendUpdatesComponent {
  expand: boolean = false;

  expandSection(){
    this.expand = !this.expand;

    if(this.expand){
      $(".custom-overlay").css('display', 'block');
    } else {
      $(".custom-overlay").css('display', 'none');
    }
  }
}
